import { render, staticRenderFns } from "./ListPage.vue?vue&type=template&id=f5cf8004&scoped=true"
import script from "./ListPage.vue?vue&type=script&lang=js"
export * from "./ListPage.vue?vue&type=script&lang=js"
import style0 from "./ListPage.vue?vue&type=style&index=0&id=f5cf8004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cf8004",
  null
  
)

export default component.exports